<template>
  <div v-if="questionData" class="question-container">
    <p :class="((route.path !== '/en' && 
    (questionData?.id === 4 || questionData?.id === 5 || questionData?.id === 8 || questionData?.id === 9 ))) 
    ? 'questionBoxLarge' : 'questionBox'" 
    class="question-text-box">
      {{ questionData.question }}
    </p>
    <div class="answers-wrapper">
      <label class="answer-row" @click="$emit('answered', questionData.firstAnswer)">
        <span class="answer-label">{{ $t('answerLabels.A') }}</span>
        <div
            class="answer-image-container peer-checked:scale-105 transition"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 270.864 60.05"
              class="w-full h-auto rounded-lg"
          >
            <path
                d="M254.534,10.489a18.376,18.376,0,0,0-6.2,1.043,4.744,4.744,0,0,1-.932.279.5.5,0,0,1-.357-.106,93.832,93.832,0,0,0,.5-9.546A2.161,2.161,0,0,0,245.381,0H2.16A2.161,2.161,0,0,0,0,2.16C0,6.822.237,35,17.966,60.05H229.574a94.1,94.1,0,0,0,11.741-22.783.483.483,0,0,1,.407-.368,1.35,1.35,0,0,1,.742.462,15.976,15.976,0,0,0,12.069,5.789,16.33,16.33,0,1,0,0-32.66M254.5,32.747a5.874,5.874,0,1,1,5.875-5.875,5.875,5.875,0,0,1-5.875,5.875"
                fill="#fff"
            />
          </svg>
          <span v-html="questionData.firstAnswer"
                class="answer-text"></span>
        </div>
      </label>

      <label class="answer-row" @click="$emit('answered', questionData.secondAnswer)">
        <span class="answer-label">{{ $t('answerLabels.B') }}</span>
        <div
            class="answer-image-container peer-checked:scale-105 transition"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 270.864 60.05"
              class="w-full h-auto rounded-lg"
          >
            <path
                d="M254.534,10.489a18.376,18.376,0,0,0-6.2,1.043,4.744,4.744,0,0,1-.932.279.5.5,0,0,1-.357-.106,93.832,93.832,0,0,0,.5-9.546A2.161,2.161,0,0,0,245.381,0H2.16A2.161,2.161,0,0,0,0,2.16C0,6.822.237,35,17.966,60.05H229.574a94.1,94.1,0,0,0,11.741-22.783.483.483,0,0,1,.407-.368,1.35,1.35,0,0,1,.742.462,15.976,15.976,0,0,0,12.069,5.789,16.33,16.33,0,1,0,0-32.66M254.5,32.747a5.874,5.874,0,1,1,5.875-5.875,5.875,5.875,0,0,1-5.875,5.875"
                fill="#fff"
            />
          </svg>
          <span v-html="questionData.secondAnswer"
                class="answer-text"
          >
        </span>
        </div>
      </label>

      <label class="answer-row" @click="$emit('answered', questionData.thirdAnswer)">
        <span class="answer-label">{{ $t('answerLabels.C') }}</span>
        <div
            class="answer-image-container peer-checked:scale-105 transition"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 270.864 60.05"
              class="w-full h-auto rounded-lg"
          >
            <path
                d="M254.534,10.489a18.376,18.376,0,0,0-6.2,1.043,4.744,4.744,0,0,1-.932.279.5.5,0,0,1-.357-.106,93.832,93.832,0,0,0,.5-9.546A2.161,2.161,0,0,0,245.381,0H2.16A2.161,2.161,0,0,0,0,2.16C0,6.822.237,35,17.966,60.05H229.574a94.1,94.1,0,0,0,11.741-22.783.483.483,0,0,1,.407-.368,1.35,1.35,0,0,1,.742.462,15.976,15.976,0,0,0,12.069,5.789,16.33,16.33,0,1,0,0-32.66M254.5,32.747a5.874,5.874,0,1,1,5.875-5.875,5.875,5.875,0,0,1-5.875,5.875"
                fill="#fff"
            />
          </svg>
          <span v-html="questionData.thirdAnswer"
                class="answer-text"></span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import {useRoute} from 'vue-router'

export default {
  props: {
    questionData: {type: Object, required: true}
  },
  data() {
    return {
      route: useRoute()
    };
  },
};
</script>

<style scoped>
.question-container {
  padding: 20px 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.question-text-box {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #EC0000;
  padding: 40px 22px;
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
}

.questionBox {
  width: 170px;
  height: 170px;
  box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
}

.questionBoxLarge {
  width: 208px;
  height: 208px;
  box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
}

.answers-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  padding-top: 75px;
}

.answer-label {
  color: white;
  font-weight: bold;
  font-size: 1.25rem;
  width: 1.5rem;
}

.answer-image-container {
  position: relative;
  position: relative;
  width: 280px;
  cursor: pointer;
  transition: transform 0.15s ease-in-out;
}

.answer-row {
 display: flex;
 align-items: center;
 gap: 12px;
}

.answer-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.answer-text {
  position: absolute;
  width: 227px;
  margin: 0 18px;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CD0000;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  pointer-events: none;
}

@media (min-width: 900px) {
  .question-container {
    padding: 50px 30px;
  }

  .question-text-box {
    padding: 55px 50px;
    font-size: 48px;
    line-height: 55px;
  }

  .questionBox {
    width: 45vw;
    height: 45vw;
    box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
  }

  .questionBoxLarge {
    width: 50vw;
    height: 50vw; 
    box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
  }

  .answers-wrapper {
    gap: 60px;
    padding-top: 150px;
  }

  .answer-label {
    font-size: 45px;
    width: 3rem;
  }

  .answer-image-container {
    width: 65vw;
  }

  .answer-text {
    width: 55vw;
    margin: 0 30px;
    font-size: 40px;
    line-height: 50px;
  }
}
</style>
